import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { EventAdapter } from './EventAdapter';
import { ImageAddMethod, ImageUploadContext } from './ImageEventAdapterTypes';

interface ImageUploadedAdapterParams {
  context: ImageUploadContext;
  add_method: ImageAddMethod;
  file_type: string;
  file_size: number;
  width: number;
  height: number;
  upload_duration: number;
}

export class UploadImageEventAdapter extends EventAdapter<ImageUploadedAdapterParams> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = sendImageUploadedEvent;

  constructor({
    context,
    add_method,
    file_type,
    file_size,
    width,
    height,
    upload_duration,
  }: ImageUploadedAdapterParams) {
    super();

    try {
      this.eventData = {
        context,
        add_method,
        file_type,
        file_size,
        width,
        height,
        upload_duration,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}

function sendImageUploadedEvent(data: ImageUploadedAdapterParams) {
  sendTeacherAmplitudeEvent(EventTypes.ImageUploaded, data);
}
